module.exports = __webpack_public_path__ + "img/atlanta_content_img_01_02.ecb3c6c4.jpg";